import { render, staticRenderFns } from "./TabUsers.vue?vue&type=template&id=106c56b5&scoped=true"
import script from "./TabUsers.vue?vue&type=script&lang=js"
export * from "./TabUsers.vue?vue&type=script&lang=js"
import style0 from "./TabUsers.vue?vue&type=style&index=0&id=106c56b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c56b5",
  null
  
)

export default component.exports